import { defineMessages } from "react-intl"

export default defineMessages({
  accountVerification: {
    defaultMessage: "Account Verification",
    id: "src.pages.RegistrationPage.accountVerification",
  },
  addPayment: {
    defaultMessage: "Add Payment",
    id: "src.pages.RegistrationPage.addPayment",
  },
  address: {
    defaultMessage: "Address",
    id: "src.pages.RegistrationPage.address",
  },
  back: {
    defaultMessage: "BACK",
    id: "src.pages.RegistrationPage.back",
  },
  createAccount: {
    defaultMessage: "Create Account",
    id: "src.pages.RegistrationPage.createAccount",
  },
  driverValidation: {
    defaultMessage: "Driver Validation",
    id: "src.pages.RegistrationPage.driverValidation",
  },
  driverVerification: {
    defaultMessage: "Driver Verification",
    id: "src.pages.RegistrationPage.driverVerification",
  },
  logIn: {
    defaultMessage: "LOG IN",
    id: "src.pages.RegistrationPage.logIn",
  },
  logOut: {
    defaultMessage: "LOG OUT",
    id: "src.pages.RegistrationPage.logOut",
  },
  paymentMethod: {
    defaultMessage: "Payment Method",
    id: "src.pages.RegistrationPage.paymentMethod",
  },
})
